import { Component, input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'eiq-tag',
  templateUrl: 'tag.component.html',
  styleUrls: ['./tag.component.scss', './_tag-theme.component.scss']
})
export class TagComponent {
  icon = input<IconDefinition>();
  text = input<string>();
}
